import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const PrivateCharterPage = () => {
  const data = getCharterBySlug('private');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default PrivateCharterPage;
